<template lang="pug">
  transition(name="fade")
    .Popup(
      @shortkey="close"
      @click="popupClose")

      transition(name="slide")
        .content(v-if="PAGE_SHOW")

          .header

            button.cancel(
              type="button"
              @click="close()")
              IconClose

            h3.title.u-text-width-bold
              template(v-if="is_edit")
                | {{ $t('generic.action._edit', [$t('generic.field.candidate_customer.s')]) }}
              template(v-else)
                | {{ $t('generic.action._add', [$t('generic.field.candidate_customer.s')]) }}

            template(v-if="is_edit")
              button.btn.btn-small.btn-danger.right-btn(
                type="button"
                @click="openDeleteModal")
                Loading(v-if="$wait.is('deleteCandidateCustomer')")
                span(v-else) {{ $t('generic.action.delete') }}

          .body
            .row
              .col.col-full
                FormItem(
                  :disabled="is_edit"
                  type="select"
                  field_name="source"
                  :label_text="'Kaynak'"
                  :data-vv-as="'Kaynak'"
                  :validate="true"
                  :required="true"
                  select_label="name"
                  track-by="id"
                  :options="candidateCustomerSourceEnumList"
                  v-model="candidate_customer.$source"
                  v-validate="'required'"
                  :error="veeErrors.first('source')"
                )
              .col.col-full
                FormItem(
                  type="text"
                  field_name="name"
                  :validate="true"
                  :required="true"
                  v-model="candidate_customer.name"
                  :label_text=" $t('generic.field.name') "
                  :data-vv-as=" $t('generic.field.name') "
                  v-validate="'required|max:64'"
                  :error="veeErrors.first('name')"
                )
              .col.col-full
                FormItem(
                  type="text"
                  field_name="surname"
                  :validate="true"
                  :required="true"
                  v-model="candidate_customer.surname"
                  :label_text="$t('generic.field.surname')"
                  :data-vv-as="$t('generic.field.surname')"
                  v-validate="'required|max:64'"
                  :error="veeErrors.first('surname')"
                )
              .col.col-full
                FormItem(
                  type="text"
                  field_name="email"
                  :validate="true"
                  v-model="candidate_customer.email"
                  :label_text="$t('generic.field.email')"
                  :data-vv-as="$t('generic.field.email')"
                  :required="true"
                  v-validate="'required|max:64'"
                  :error="veeErrors.first('email')"
                )
              .col.col-full
                FormItem(
                  type="text"
                  field_name="company_name"
                  :validate="true"
                  v-model="candidate_customer.company_name"
                  :label_text="'Şirket Adı/Tabela Adı'"
                  :data-vv-as="'Şirket Adı/Tabela Adı'"
                  v-validate="'max:64'"
                  :error="veeErrors.first('company_name')"
                )
              .col.col-full
                FormItem(
                  type="tel"
                  field_name="phone-number"
                  :validate="true"
                  v-model="candidate_customer.phone_number"
                  :label_text="$t('set_preferences.field.phone_number')"
                  :data-vv-as="$t('set_preferences.field.phone_number')"
                  v-validate="'max:64'"
                  :error="veeErrors.first('phone_number')"
                )
              .col.col-full
                FormItem(
                  type="select"
                  field_name="registration_source_id"
                  :label_text="'Nereden Buldu'"
                  :data-vv-as="'Nereden Buldu'"
                  select_label="name"
                  track-by="name"
                  :options="registration_source_list"
                  v-model="candidate_customer.$registrationSource"
                  :error="veeErrors.first('registration_source_id')"
                )
              .col.col-full
                FormItem(
                  type="select"
                  field_name="interest_list"
                  :label_text="'İlgi Alanı'"
                  select_label="name"
                  track-by="name"
                  :multiple="true"
                  :options="interestList"
                  v-model="candidate_customer.$activeInterest"
                  :error="veeErrors.first('registration_source_id')"
                )
          .footer
            button.cancel.btn.btn-line(
              type="button"
              @click="close()"
            ) {{ $t('generic.action.cancel') }}

            button.save.btn.btn-primary(
              type="button"
              @click="save"
              :disabled="is_loading")
              Loading(v-if="is_loading")
              span(v-else) {{ $t('generic.action.save') }}
      Modal(
        v-if="show_delete_modal"
        :acceptText=" $t('generic.action.delete') "
        :denyText=" $t('generic.action.cancel') "
        type="danger"
        :is_loading="$wait.is('deleteCandidateCustomer')"
        @onAccept="onDelete"
        @onDeny="closeDeleteModal"
      )
        p {{ $t('generic.msg.confirmation') }}

</template>
<script>
  import { CandidateCustomer } from '@/model/CandidateCustomer'
  import _cloneDeep from 'lodash/cloneDeep'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { CandidateCustomerSourceEnumList, InterestList } from '@/utils/constant'


  export default {
    name: 'CandidateCustomerPopup',

    data () {
      return {
        PAGE_SHOW: false,
        show_delete_modal: false,
        candidate_customer: new CandidateCustomer(),
        candidateCustomerSourceEnumList: CandidateCustomerSourceEnumList.filter(o => !o.hidden),
        interestList: InterestList
      }
    },

    created () {
      if (this.is_edit) {
        this.candidate_customer = new CandidateCustomer(_cloneDeep(this.$route.params.candidate_customer))
      }
    },

    computed: {
      ...mapState('App', [
        'registration_source_list',
      ]),

      is_edit () {
        return this.$route.name === 'candidate-customer-edit'
      },

      is_loading () {
        return this.$wait.is('createCandidateCustomer')
      }
    },

    methods: {
      ...mapActions('CandidateCustomer', [
        'createCandidateCustomer',
        'deleteCandidateCustomer'
      ]),

      ...mapMutations('CandidateCustomer', [
        'UPDATE_CANDIDATE_CUSTOMER'
      ]),

      save () {
        this.$validator._base.validateAll().then(result => {
          if (!result) return
          this.createCandidateCustomer({
            item: this.candidate_customer,
            edit: this.is_edit
          })
            .then(res => {
              this.UPDATE_CANDIDATE_CUSTOMER(this.candidate_customer)
              this.close()
            })
            .catch(err => {
              this.showErrorToast(this.$getErrorMessage(this, err))
            })
        })
      },
      onDelete () {
        this.deleteCandidateCustomer(this.candidate_customer.id).then(
          res => {
            this.UPDATE_CANDIDATE_CUSTOMER(null)
            this.$router.push({
              name: 'candidate-customer'
            })
            this.showSuccessToast(this.$t('generic.msg.successful'))
          }
        ).catch(err => {
          this.closeDeleteModal()
          this.showErrorToast(this.$getErrorMessage(this.err))
        })
      },
      openDeleteModal () {
        this.show_delete_modal = true
      },

      closeDeleteModal () {
        this.show_delete_modal = false
      },

      popupClose (event) {
        if (event.target.classList.contains('Popup')) {
          this.close()
        }
      },

      close (reset = false) {
        if (!this.is_edit) {
          this.$router.push({
            name: 'candidate-customer'
          })
        } else {
          this.$router.push({
            name: 'candidate-customer-view'
          })
        }
      }
    },

    beforeRouteEnter (to, from, next) {
      next(vm => {
        setTimeout(() => {
          vm.PAGE_SHOW = true
        }, 0)
      })
    },

    beforeRouteLeave (to, from, next) {
      this.PAGE_SHOW = false
      setTimeout(() => {
        next()
      }, 150)
    },


  }

</script>
<style lang="scss" scoped>
  .toggle-title {
    color: $color-gray;
    margin: 15px 0;
  }

  .toggle {
    margin-bottom: 15px;
  }
</style>
